export * from './Label';
export * from './Label.Props';